<template>
  <v-dialog
    v-model="isVisible"
    :width="dialogWidth"
    :hide-overlay="hideOverlay"
  >
    <v-card color="secondary">
      <psReportHeader
        :show-search-bar="false"
        :show-add-button="false"
        :show-save-button="false"
        :show-refresh-button="false"
        :show-close-button="true"
        :show-elipsis-button="false"
        :show-check-button="false"
        header-title="Properties"
        alignIcons="right"
        alignText="left"
        @close-event="headerCloseEvent"
      />
      <table cellspacing="10" cellpadding="10">
        <tr><td>Iframe Source:</td><td>{{source}}</td></tr>
        <tr><td>Component Name:</td><td>{{component}}</td></tr>
        <tr><td>Parameters:</td><td>{{parameters}}</td></tr>
        <tr><td>Menu URL:</td><td>../UI/Pages/Help/P4/P4.html</td></tr>
      </table>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: "PsProperties",
    props: {
      value: Boolean,
      source: {
        type: String,
        required: true
      },
      component: {
        type: String,
        required: true
      },
      parameters: {
        type: String,
        required: true
      },
      dialogWidth: { 
        type: String, 
        required: false,
        default: "auto " // dumb, but it has to have the space after auto for it to work properly
      },
      headerCloseEvent: {
          type: Function,
          required: false
      },
      hideOverlay: { 
        type: Boolean, 
        default: false 
      },
      showButtons: false
    },
    computed: {
      isVisible: {
        get () {
          if (this.value === false) {
            if (!this.isMounted) return this.value;
          }
          return this.value;
        },
        set (value) {
          this.$emit("input", value);
        }
      }
    }
  };
</script>
